/**
 * Wohnform – EINE Quelle für Lebenssituation und Vergütung (Spiegel von backend/services/wohnform.py).
 * Gespeichert am Klienten: wohnform (+ wohnform_seit, optional wohnform_vbvg). Die Anschrift legt die Wohnform nie fest.
 */
export const STATIONAER = 'stationaer';
export const ANDERE = 'andere';
export const KLAERUNG = 'klaerung';
export const OFFEN = 'offen';

export const WOHNFORM_KATALOG = [
  { value: 'eigene_wohnung', label: 'Eigene Wohnung', vbvg: ANDERE },
  { value: 'mietwohnung', label: 'Mietwohnung', vbvg: ANDERE },
  { value: 'eigentum', label: 'Wohneigentum', vbvg: ANDERE },
  { value: 'bei_angehoerigen', label: 'Bei Angehörigen', vbvg: ANDERE },
  { value: 'obdachlos', label: 'Ohne festen Wohnsitz', vbvg: ANDERE },
  { value: 'pflegeheim', label: 'Pflegeheim', vbvg: STATIONAER },
  { value: 'wohnheim', label: 'Wohnheim (stationär)', vbvg: STATIONAER },
  { value: 'heim', label: 'Heim / stationäre Einrichtung', vbvg: STATIONAER },
  { value: 'stationaer', label: 'Stationäre Einrichtung', vbvg: STATIONAER },
  { value: 'betreutes_wohnen', label: 'Betreutes Wohnen (ambulant)', vbvg: KLAERUNG },
  { value: 'wohngemeinschaft', label: 'Wohngemeinschaft', vbvg: KLAERUNG },
  { value: 'psychiatrie', label: 'Psychiatrie / Klinik', vbvg: KLAERUNG },
  { value: 'maßregelvollzug', label: 'Maßregelvollzug', vbvg: KLAERUNG },
  { value: 'jva', label: 'JVA', vbvg: KLAERUNG },
  { value: 'sonstiges', label: 'Sonstiges', vbvg: KLAERUNG },
];

const ALIAS = { heimunterbringung: 'pflegeheim', einrichtung: 'heim', abw: 'betreutes_wohnen', wg: 'wohngemeinschaft',
  massregelvollzug: 'maßregelvollzug', ohne_festen_wohnsitz: 'obdachlos', 'stationär': 'stationaer' };
const LEER = new Set(['', 'nicht_angegeben', 'unbekannt', 'offen', 'none', 'k.a.']);

export const VBVG_LABEL = {
  [STATIONAER]: 'Stationär bzw. gleichgestellte Wohnform',
  [ANDERE]: 'Andere Wohnform (nicht stationär)',
  [KLAERUNG]: 'VBVG-Einordnung klären',
  [OFFEN]: 'Wohnform offen – klären',
};

/** Auswahl im Formular: "offen" + Katalog (der leere Wert wird als nicht_angegeben gespeichert = offen) */
export const WOHNFORM_OPTIONS = [{ value: 'nicht_angegeben', label: 'Offen / nicht angegeben' }, ...WOHNFORM_KATALOG];

export function normalisiereWohnform(wert) {
  const w = String(wert || '').trim().toLowerCase().replace(/ /g, '_');
  if (LEER.has(w)) return null;
  return ALIAS[w] || w;
}

export function wohnformLabel(wert) {
  const w = normalisiereWohnform(wert);
  if (!w) return 'Offen';
  return WOHNFORM_KATALOG.find(x => x.value === w)?.label || String(wert);
}

/** VBVG-Einordnung aus klient.wohnform (+ wohnform_vbvg). Gleiche Regeln wie das Backend. */
export function wohnformEinordnung(klient) {
  const w = normalisiereWohnform(klient?.wohnform);
  const manuell = String(klient?.wohnform_vbvg || '').toLowerCase();
  if (!w) return { kategorie: OFFEN, label: VBVG_LABEL[OFFEN], wohnform: null, manuell: false };
  if (manuell === STATIONAER || manuell === ANDERE) return { kategorie: manuell, label: VBVG_LABEL[manuell], wohnform: w, manuell: true };
  const kat = WOHNFORM_KATALOG.find(x => x.value === w)?.vbvg || KLAERUNG;
  return { kategorie: kat, label: VBVG_LABEL[kat], wohnform: w, manuell: false };
}

/** Darf/muss die VBVG-Einordnung manuell festgelegt werden? (Wohnform vorhanden, aber nicht eindeutig) */
export function vbvgFestlegungNoetig(klient) {
  const w = normalisiereWohnform(klient?.wohnform);
  if (!w) return false;
  return (WOHNFORM_KATALOG.find(x => x.value === w)?.vbvg || KLAERUNG) === KLAERUNG;
}
